module.exports = __webpack_public_path__ + "img/seto-isao.021cd8da.png";